import { FunctionComponent, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { RoutesList } from '../../../../routes/Routes';
import { FloodingType, useDrainsStore } from '../../../../hooks/useDrainsStore';
import { BinaryQuestionTemplate } from '@templates';
import { ErrorMessages } from '@types';
import { parseZodErrors, stringFieldSchema } from '@utils';
import { FLOODING_SELECT_OPTIONS_ERROR } from '../../../../constants/errors';
import { FOOTPATH, ROAD, FOOTPATH_LABEL } from '../../../../constants/drains';
import { ZodError } from 'zod';

export const FloodAffecting: FunctionComponent = () => {
  const navigate = useNavigate();
  const {
    update,
    resetSelective,
    data: { floodType },
  } = useDrainsStore();
  const [errorMessages, setErrorMessages] = useState<ErrorMessages[]>([]);
  const title = 'What is the flooding affecting?';

  const options = [
    {
      id: FOOTPATH,
      title: FOOTPATH,
      labelText: FOOTPATH_LABEL,
      isDefault: floodType === FOOTPATH,
      isLabelBold: false,
    },
    {
      id: ROAD,
      title: ROAD,
      labelText: ROAD,
      isDefault: floodType === ROAD,
      isLabelBold: false,
    },
  ];

  const handleChange = (selection: string) => {
    setErrorMessages([]);
    const updatedSelection = options.filter(
      (type) => type.labelText === selection,
    )[0].id as FloodingType;

    if (updatedSelection) {
      update('floodType', updatedSelection);
    } else {
      resetSelective();
    }
  };

  const buttonPrevious = {
    onClick: () => {
      navigate(RoutesList.PRIVATE_PROPERTY_ISSUE);
    },
  };

  const buttonNext = {
    onClick: async () => {
      try {
        stringFieldSchema(
          'floodType',
          FLOODING_SELECT_OPTIONS_ERROR.required.message,
        ).parse({
          floodType,
        });
        navigate(RoutesList.DESCRIBE_ISSUE);
      } catch (error) {
        const validationErrors = parseZodErrors(error as ZodError);
        setErrorMessages(
          validationErrors.map((error: ErrorMessages) => ({
            message: FLOODING_SELECT_OPTIONS_ERROR.required.message,
            path: error.path,
          })),
        );
      }
    },
  };

  return (
    <BinaryQuestionTemplate
      title={title}
      options={options}
      errorPath="floodType"
      errorMessages={errorMessages}
      buttonNext={buttonNext}
      buttonPrevious={buttonPrevious}
      onChange={handleChange}
    />
  );
};
